import ServiceCard from "../shared/ServiceCard";
import { useServices } from "../../context/ServicesContext";
import Eyebrow from "../shared/Eyebrow";
import RevealText from "../shared/RevealText";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FeaturedServices({ limit = 9 }) {
  const { services: SERVICES } = useServices();
  return (
    <section
      className="bg-ink py-24 md:py-32 border-t border-charcoal/50"
      data-testid="featured-services"
    >
      <div className="container-emilio">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Eyebrow>Our Services</Eyebrow>
            <RevealText
              as="h2"
              text={"Professional cleaning\nfor every space."}
              className="mt-4 font-display font-extrabold text-white text-display max-w-2xl"
            />
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-emerald font-semibold text-sm hover:gap-3 transition-all"
            data-testid="featured-services-view-all"
          >
            View all services <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.slice(0, limit).map((s, i) => (
            <ServiceCard key={s.slug} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
